import { Button, Box, Typography, Paper, Divider, useTheme } from "@mui/material";
import { useState } from "react";
import DataGridMAIQ from "app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ";
import DataGridTypes from "types/DataGridTypes";
import AddResourceModal from "./AddResourceModal";
import ResourceDetailsModal from "./ResourceDetailsModal";
import { Resource } from "../../types";
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import ButtonMAIQ from "app/components/ReusableUIComponents/LowLevelComponents/buttons/ButtonMAIQ";

const ResourcesTab = () => {
  const [isAddResourceModal, setIsAddResourceModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedResource, setSelectedResource] = useState<Resource | null>(null);
  const theme = useTheme();

  const handleAddResourceModalOpen = () => {
    setIsAddResourceModal(true);
  };

  const handleResourceClick = (resource: any) => {
    setSelectedResource(resource.row);
  };

  const handleCloseResourceDetails = () => {
    setSelectedResource(null);
  };

  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        padding: { xs: 1, sm: 2 }
      }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 2.5,
          display: "flex",
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: "space-between",
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <SettingsIcon 
            sx={{ 
              color: theme.palette.primary.main,
              fontSize: 28 
            }} 
          />
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.1rem',
                color: theme.palette.primary.main
              }}
            >
              Resource Management
            </Typography>
            <Typography 
              variant="body2" 
              color="text.primary"
              sx={{ fontSize: '0.85rem' }}
            >
              Create and manage system resources
            </Typography>
          </Box>
        </Box>
        
        <ButtonMAIQ
          variant="contained"
          color="primary"
          onClick={handleAddResourceModalOpen}
          startIcon={<AddIcon />}
        >
          Add New Resource
        </ButtonMAIQ>
      </Paper>
      
      <Divider sx={{ opacity: 0.5 }} />

      <Box 
        sx={{ 
          flexGrow: 1, 
          minHeight: 400,
          '& .MuiDataGrid-root': {
            border: 'none',
            borderRadius: 1.5,
            boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          },
        }}
      >
        <DataGridMAIQ 
          key={refreshKey}
          type={DataGridTypes.RESOURCES()}
          onRowClick={handleResourceClick}
        />
      </Box>

      <AddResourceModal
        open={isAddResourceModal}
        onClose={() => setIsAddResourceModal(false)}
        onSuccess={() => setRefreshKey(prev => prev + 1)}
      />
      {selectedResource && (
        <ResourceDetailsModal
          open={!!selectedResource}
          onClose={handleCloseResourceDetails}
          resource={selectedResource}
          onSuccess={() => {
            setRefreshKey(prev => prev + 1);
            handleCloseResourceDetails();
          }}
        />
      )}
    </Box>
  );
};

export default ResourcesTab; 